declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../../../services/hcp.service';
import { ActorEducationInfoRequest, ActorEducationInfoController } from '../../../../../models/profileinfo/profileinfo.model';
import { NgbEducationInfoModal } from '../../educationinfo/modals/educationinfo.modal';
import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
//import * as moment from 'moment';
import { CustomDateTimeService } from '../../../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'educationinfov2',
  templateUrl: './educationinfov2.component.html',
  styleUrls: ['./educationinfov2.component.scss']
})

export class EducationInfoV2Component implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  CurrentActorEducationInfoRequest: ActorEducationInfoRequest;
  CurrentActorEducationInfoController: ActorEducationInfoController[];

  //
  CurrentActorEditEducationInfoRequest: ActorEducationInfoRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;



  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();



  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEducationInfoController = new Array<ActorEducationInfoController>();
    this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;

    this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEditEducationInfoRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CanShow === 1) {
      this.GetActorEducationInfoController();
    }

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorEducationInfoRequest = null;
    this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 1;
    this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
   

  }
  clearData() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorEducationInfoRequest = null;
    this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 1;
    this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  public onInputValidFrom(value: Date): void {

    console.log('value-->' + value);

    this.CurrentActorEditEducationInfoRequest.StartFrom = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditEducationInfoRequest.CompletedAt = value;
  }

  GetActorEducationInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorEducationInfoController(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorEducationInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit() {
   // alert("On Submit");
    if (this.ShowList) {

      return;
    }
    else {
    //  alert("not showing list, proceed to savve...");
    }
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 1;
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEducationInfoRequest.StartFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEducationInfoRequest.StartFrom);
    //  this.CurrentActorEducationInfoRequest.CompletedAt = this.customdatetimeservice.converToLocalTime(this.CurrentActorEducationInfoRequest.CompletedAt);
    //  //console.log('ssssssssssssssssssssssssssssssss->'+this.CurrentActorEducationInfoRequest.StartFrom);
    //  //console.log('asdddddddddddddddddddd--->' + a);

    //  //this.CurrentActorEducationInfoRequest.StartFrom = a;

    //  //console.log('asdddddddddddddddddddd--->' + this.CurrentActorEducationInfoRequest.StartFrom);

    //  //if (this.CurrentActorEducationInfoRequest.StartFrom != null && this.CurrentActorEducationInfoRequest.StartFrom.getFullYear() > 1990) {
    //  //  this.CurrentActorEducationInfoRequest.StartFrom.setMinutes(this.CurrentActorEducationInfoRequest.StartFrom.getMinutes() + -(this.CurrentActorEducationInfoRequest.StartFrom.getTimezoneOffset()))


    //  //}
    //  //if (this.CurrentActorEducationInfoRequest.CompletedAt != null && this.CurrentActorEducationInfoRequest.CompletedAt.getFullYear() > 1990) {

    //  //  this.CurrentActorEducationInfoRequest.CompletedAt.setMinutes(this.CurrentActorEducationInfoRequest.CompletedAt.getMinutes() + -(this.CurrentActorEducationInfoRequest.CompletedAt.getTimezoneOffset()))

    //  //}

    //}

    if (this.ValidFrom != null) {



      this.CurrentActorEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEducationInfoRequest.CompletedAt = new Date(this.parserFormatter.format(this.ValidTo));;
    }
   
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEducationInfoController();
           // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }
  edit_(EditCurrentActorEducationInfoController: ActorEducationInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditEducationInfoRequest.EducationCode = EditCurrentActorEducationInfoController.EducationCode;
    this.CurrentActorEditEducationInfoRequest.ActorCode = EditCurrentActorEducationInfoController.ActorCode;
    this.CurrentActorEditEducationInfoRequest.InstituteName = EditCurrentActorEducationInfoController.InstituteName;
    this.CurrentActorEditEducationInfoRequest.InstituteType = EditCurrentActorEducationInfoController.InstituteType;
    this.CurrentActorEditEducationInfoRequest.Location = EditCurrentActorEducationInfoController.Location;
    this.CurrentActorEditEducationInfoRequest.CourseStudy = EditCurrentActorEducationInfoController.CourseStudy;
    this.CurrentActorEditEducationInfoRequest.StartFrom = EditCurrentActorEducationInfoController.StartFrom;
    this.CurrentActorEditEducationInfoRequest.CompletedAt = EditCurrentActorEducationInfoController.CompletedAt;


    if (this.CurrentActorEditEducationInfoRequest.StartFrom != null) {
      var SValidFrom = new Date(this.CurrentActorEditEducationInfoRequest.StartFrom);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditEducationInfoRequest.CompletedAt != null) {
      var SValidTo = new Date(this.CurrentActorEditEducationInfoRequest.CompletedAt);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }



    this.CurrentActorEditEducationInfoRequest.IsGraduate = EditCurrentActorEducationInfoController.IsGraduate;
    this.CurrentActorEditEducationInfoRequest.CourseType = EditCurrentActorEducationInfoController.CourseType;

    this.CurrentActorEditEducationInfoRequest.Subjects = EditCurrentActorEducationInfoController.Subjects;
    this.CurrentActorEditEducationInfoRequest.Remarks = EditCurrentActorEducationInfoController.Remarks;
   

    this.isNew = false;
    this.isEdit = true;


  }
  onEditSubmit() {

   // alert("On edit Submit");
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 2;
    //console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);
    //console.log('this.CurrentActorEditEducationInfoRequest.CompletedAt...>' + this.CurrentActorEditEducationInfoRequest.CompletedAt);

    //var a = this.converToLocalTime(this.CurrentActorEditEducationInfoRequest.StartFrom);
    //console.log('a----------------------->'+a);
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditEducationInfoRequest.StartFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEducationInfoRequest.StartFrom);
    //  this.CurrentActorEditEducationInfoRequest.CompletedAt = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEducationInfoRequest.CompletedAt);
    //  //this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.CurrentActorEditEducationInfoRequest.StartFrom);

    //  //this.CurrentActorEditEducationInfoRequest.CompletedAt = new Date(this.CurrentActorEditEducationInfoRequest.CompletedAt);


    //  //if (this.CurrentActorEditEducationInfoRequest.StartFrom != null && this.CurrentActorEditEducationInfoRequest.StartFrom.getFullYear() > 1990) {
    //  //  console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);

    //  //  this.CurrentActorEditEducationInfoRequest.StartFrom.setMinutes(this.CurrentActorEditEducationInfoRequest.StartFrom.getMinutes() + -(this.CurrentActorEditEducationInfoRequest.StartFrom.getTimezoneOffset()))

    //  //  console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);


    //  //}
    //  //if (this.CurrentActorEditEducationInfoRequest.CompletedAt != null && this.CurrentActorEditEducationInfoRequest.CompletedAt.getFullYear() > 1990) {

    //  //  this.CurrentActorEditEducationInfoRequest.CompletedAt.setMinutes(this.CurrentActorEditEducationInfoRequest.CompletedAt.getMinutes() + -(this.CurrentActorEditEducationInfoRequest.CompletedAt.getTimezoneOffset()))

    //  //}

    //}



    if (this.ValidFrom != null) {



      this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditEducationInfoRequest.CompletedAt = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEditEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEducationInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }





  del_(EducationCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(EducationCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(EducationCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 3;
    this.CurrentActorEducationInfoRequest.EducationCode = EducationCode;
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetActorEducationInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }


  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



   converToLocalTime(serverDate) :Date{
     if (serverDate != null) {
       var dt = new Date(Date.parse(serverDate));
       var localDate = dt;

       var gmt = localDate;
       var min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
       var localNow = new Date().getTimezoneOffset(); // get the timezone
       // offset in minutes
       var localTime = min - localNow; // get the local time

       var dateStr = new Date(localTime * 1000 * 60);
       // dateStr = dateStr.toISOString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"); // this will return as just the server date format i.e., yyyy-MM-dd'T'HH:mm:ss.SSS'Z'
       //dateStr = dateStr.toString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

       console.log('dateStr-------------' + dateStr);
       console.log('dateStr.toISOString-------------' + dateStr.toISOString());
       console.log('dateStr.toISOString to date-------------' + new Date(dateStr.toISOString()));
       return dateStr;
     }
     else {
       return null;
     }
}

}
